// extracted by mini-css-extract-plugin
module.exports = {"amenities":"_9fvq-Pvo_8kN","amenities__item":"_1LyLbMGdMSsR","amenities__item_unavailable":"_3enMoSxPXfru"};